import { Constants } from "constants/Constants";

const ImageFromStrapiMedia = (media: any) => ({
  uri: `${Constants.ROOT_URL}${media?.url}`,
});

export default ImageFromStrapiMedia;
